import api from "../../../../service/api";
import routes from "../../../../service/apiRoutes";

export const listPurchasedProducts = () => api.get(`${routes.listOrders}`)
